export const SUPPORT_EMAIL = "support@reclaim.ai";
